"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[typeof Symbol === "function" ? Symbol.iterator : "@@iterator"] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var msal_1 = require("msal");

var AuthenticationProvider = function () {
  function AuthenticationProvider(authorityUrl, clientId, isIE) {
    if (isIE === void 0) {
      isIE = false;
    }

    var config = {
      auth: {
        authority: authorityUrl,
        clientId: clientId
      },
      cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: isIE
      }
    };
    this.app = new msal_1.UserAgentApplication(config);
    this.clientId = clientId;
  }

  AuthenticationProvider.isAdmin = function (response) {
    return AuthenticationProvider.hasRole(response, 'Admin');
  };

  AuthenticationProvider.hasRole = function (response, role) {
    var roles = response.idTokenClaims.roles || '';
    return roles.includes(role);
  };

  AuthenticationProvider.requiresInteraction = function (errorCode) {
    if (!errorCode) {
      return false;
    }

    return errorCode.indexOf('consent_required') > -1 || errorCode.indexOf('interaction_required') > -1 || errorCode.indexOf('login_required') > -1;
  };

  AuthenticationProvider.getAuthenticationParameters = function (clientId) {
    return {
      scopes: ["api://" + clientId + "/access_usermanagement"]
    };
  };

  AuthenticationProvider.prototype.login = function () {
    return __awaiter(this, void 0, void 0, function () {
      var request;
      return __generator(this, function (_a) {
        request = AuthenticationProvider.getAuthenticationParameters(this.clientId);
        return [2, this.app.loginPopup(request)];
      });
    });
  };

  AuthenticationProvider.prototype.acquireToken = function () {
    return __awaiter(this, void 0, void 0, function () {
      var request, authResponse, ex_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            request = AuthenticationProvider.getAuthenticationParameters(this.clientId);
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 6]);

            return [4, this.app.acquireTokenSilent(request)];

          case 2:
            authResponse = _a.sent();
            return [3, 6];

          case 3:
            ex_1 = _a.sent();
            if (!AuthenticationProvider.requiresInteraction(ex_1.errorCode)) return [3, 5];
            return [4, this.app.acquireTokenPopup(request)];

          case 4:
            authResponse = _a.sent();
            _a.label = 5;

          case 5:
            throw ex_1;

          case 6:
            return [2, Promise.resolve(authResponse)];
        }
      });
    });
  };

  AuthenticationProvider.prototype.logout = function () {
    this.app.logout();
  };

  AuthenticationProvider.prototype.getAccountName = function () {
    var account = this.app.getAccount();
    return account ? account.name : '';
  };

  AuthenticationProvider.prototype.isLoggedIn = function () {
    return !!this.app.getAccount();
  };

  AuthenticationProvider.prototype.getRoles = function () {
    var account = this.app.getAccount();
    return account ? account.idTokenClaims.roles : '';
  };

  return AuthenticationProvider;
}();

exports.AuthenticationProvider = AuthenticationProvider;